import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Box,
  IconButton,
  Divider,
} from "@mui/material";
import { CloseBig } from "@tiny/icons";
import { SplitBranch } from "../types";

const DELETE_ALL = "__all__";

interface DeleteSplitDialogProps {
  open: boolean;
  branches: SplitBranch[];
  onCancel: () => void;
  /** null deletes every path. */
  onConfirm: (keepBranchId: string | null) => void;
}

function DeleteSplitDialog({
  open,
  branches,
  onCancel,
  onConfirm,
}: DeleteSplitDialogProps) {
  const [selected, setSelected] = React.useState<string>(DELETE_ALL);

  const handleConfirm = () => {
    onConfirm(selected === DELETE_ALL ? null : selected);
    setSelected(DELETE_ALL);
  };

  const handleCancel = () => {
    setSelected(DELETE_ALL);
    onCancel();
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 0,
            m: 0,
          }}
        >
          <Typography variant="h3">Delete traffic split</Typography>
          <IconButton onClick={handleCancel}>
            <CloseBig />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="inherit" color="grey">
          Which path should stay in the workflow?
        </Typography>
        <RadioGroup
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
          sx={{ mt: 3 }}
        >
          {branches.map((branch) => (
            <FormControlLabel
              key={branch.id}
              value={branch.id}
              control={<Radio />}
              label={`Keep ${branch.name}, delete the other paths`}
            />
          ))}
          <FormControlLabel
            value={DELETE_ALL}
            control={<Radio />}
            label="Delete all paths"
          />
        </RadioGroup>
        <Divider sx={{ mt: 4 }} />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={handleConfirm}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteSplitDialog;
